import {
  khubTripsData,
  khubTripOrderData,
  khubTripsRouteData,
  tripsandOrderCountData,
  khubDeleteTrip
} from './deliveryTrackingSlices/khubtripsSlice';

import {
  addDeliveryTripSlice,
  contactDataReducer,
  contactNumberReducer,
  driverIdReducer,
  getDeliveryAndOrdersReducer,
  getOrderByStatusData,
  getTripsDropdownData,
  ordersReassignData,
  previewDeliveryTripsData,
  updateDeliveryReducer
} from './deliveryTrackingSlices/deliverytripsSlice';
import {
  customerAddReducer,
  customerDeleteReducer,
  customerGetReducer,
  customerUpdateReducer
} from './deliveryTrackingSlices/customerDeliverySlice';
import {
  getOrderFilterListReducer,
  getOrderFilterReducer,
  getOrderLoadConfigDimensionReducer,
  getOrderLoadConfigReducer,
  loadReducer
} from './deliveryTrackingSlices/addDeliveryLoadsSlice';
import {
  getOrdersSlice,
  addExcelReducer,
  addOrderReducer,
  getOrdersCountSlice,
  deleteOrderReducer
} from './deliveryTrackingSlices/OrderSlice';
import {
  addDeliveryDispatchReducer,
  deactivateDeliveryDispatchReducer,
  deleteDeliveryDispatchReducer,
  dispatchGetPreviewReducer,
  getAllDispatchReducer,
  getDriverDropdownReducer,
  getLoadsDropdownReducer,
  getTrucksDropdownReducer,
  getVehiclesDropdownReducer,
  updateDeliveryDispatchReducer,
  viewDispatchReducer
} from './deliveryTrackingSlices/dispatchSlice';
import { loadConfigReducer } from './deliveryTrackingSlices/loadConfigSlice';

export const deliveryTrackingReducer = {
  khubtrips: khubTripsData,
  addDeliveryTripSlice: addDeliveryTripSlice,
  khubtriporders: khubTripOrderData,
  khubtripsroute: khubTripsRouteData,
  tripsandOrderCountData: tripsandOrderCountData,
  tripKhubDelete: khubDeleteTrip,

  driverId: driverIdReducer,
  updateDelivery: updateDeliveryReducer,
  contactNumber: contactNumberReducer,
  contactData: contactDataReducer,
  deliveryAndOrders: getDeliveryAndOrdersReducer,
  customerAdd: customerAddReducer,
  customerGet: customerGetReducer,
  customerUpdate: customerUpdateReducer,
  customerDelete: customerDeleteReducer,
  orderrescheduleTrips: getTripsDropdownData,
  reassignOrders: ordersReassignData,
  deliveryPreview: previewDeliveryTripsData,
  orderByStatus: getOrderByStatusData,

  //loads
  load: loadReducer,
  getOrderFilter: getOrderFilterListReducer,
  getLoadOrder: getOrderFilterReducer,
  getOrderLoadConfig: getOrderLoadConfigReducer,
  getOrderLoadConfigDimension: getOrderLoadConfigDimensionReducer,

  //order
  // loadConfig: loadConfigReducer
  getOrders: getOrdersSlice,
  getOrdersCount: getOrdersCountSlice,
  addExcel: addExcelReducer,
  addOrder: addOrderReducer,
  deleteOrder: deleteOrderReducer,

  dispatchGetPreview: dispatchGetPreviewReducer,
  getLoadsDropdown: getLoadsDropdownReducer,
  getTrucksDropdown: getTrucksDropdownReducer,
  getDriverDropdown: getDriverDropdownReducer,
  addDeliveryDispatch: addDeliveryDispatchReducer,
  getAllDispatch: getAllDispatchReducer,
  viewDispatch: viewDispatchReducer,
  deleteDeliveryDispatch: deleteDeliveryDispatchReducer,
  deactivateDeliveryDispatch: deactivateDeliveryDispatchReducer,
  updateDeliveryDispatch: updateDeliveryDispatchReducer,
  getVehiclesDropdown: getVehiclesDropdownReducer,
  loadConfig: loadConfigReducer
};
